/**
 * What the "Welche Events an Meta?" table (Tracking, meta_event_allowlist) and the
 * per-source switch `hq_rule.meta_hq_only` mean for Meta (TASK-253, S16). The table
 * is literal: HQLead ticked = Meta gets its own event "HQLead". The switch only
 * changes the "Lead" part: a source with it reports HQ leads as "Lead", normal leads not.
 */
export function hqMetaSummary(
  allowlist: string[] | null,
  state: "loading" | "error" | "ready" = "ready",
  metaHqOnly = false,
): string {
  if (state === "loading") return "Meldungs-Tabelle wird geladen.";
  if (state === "error") return "Meldungs-Tabelle nicht lesbar.";
  const hq = !!allowlist?.includes("HQLead");
  const lead = !!allowlist?.includes("Lead");
  if (metaHqOnly) {
    const own = hq ? " Zusätzlich geht das eigene Ereignis HQLead an Meta." : "";
    return lead
      ? `Von dieser Quelle geht nur HQ als Lead an Meta.${own}`
      : `Von dieser Quelle geht kein Lead an Meta, weil Lead in der Meldungs-Tabelle nicht angehakt ist.${own}`;
  }
  if (hq && !lead) return "Meta bekommt das eigene Ereignis HQLead, keine Leads.";
  if (hq && lead) return "Meta bekommt Leads und das eigene Ereignis HQLead.";
  if (lead) return "Meta bekommt alle Leads. HQ-Leads gehen nicht gesondert an Meta.";
  return "Lead und HQ-Lead sind in der Meldungs-Tabelle (Tracking) nicht angehakt, Meta bekommt keine Leads.";
}
